<template>
  <div class="p-4">
    <div class="vx-row" v-if="myOrganizations && (myOrganizations.superOrgs.length > 0 || myOrganizations.subOrgs.length > 0)">
      <!-- Super Orgs / Owned Orgs -->
      <div v-for="(myOrgs, index) in myOrganizations.superOrgs" :key="'superOrg-' + index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
        <vx-card v-if="myOrgs.status !== 'DEACTIVATED'" class="org-card overflow-hidden">
          <div class="items-center flex flex-col justify-between" style="min-height: 360px">
            <div>
              <vs-avatar v-if="myOrgs.logo" class="my-4 profile-picture" size="160px" :src="constants.s3Bucket + '/organization/logo/' + myOrgs.logo" />
              <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')" />
              <div class="mb-base"><h2 class="mb-1 text-center">{{ myOrgs.name }}</h2><p class="text-center">{{ myOrgs.website }}</p></div>
            </div>
            <vs-button class="mb-base" size="large" color="primary" type="filled" @click.stop="manageOrganization(myOrgs.slug || myOrgs._id)">Manage</vs-button>
          </div>
        </vx-card>
      </div>

      <!-- Sub Orgs / Invited Orgs -->
      <div v-for="(myOrgs, index) in myOrganizations.subOrgs" :key="'subOrg-' + index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base" :class="myOrgs.status === 'DEACTIVATED' ? 'hidden' : ''">
        <vx-card class="org-card overflow-hidden" v-if="myOrgs.status !== 'DEACTIVATED'">
          <div class="items-center flex flex-col justify-between" style="min-height: 360px">
            <div>
              <vs-avatar v-if="myOrgs.organization[0] && myOrgs.organization[0].logo" class="my-4 profile-picture" size="160px" :src="constants.s3Bucket + '/organization/logo/' + myOrgs.organization[0].logo" />
              <vs-avatar v-else class="my-4 profile-picture" size="160px" :src="require('@/assets/images/icons/organization/business_black_36dp.svg')" />
              <div class="mb-base"><h2 class="mb-1 text-center">{{ myOrgs.organization[0].name }}</h2><p class="text-center">{{ myOrgs.organization[0].website }}</p></div>
            </div>
            <div v-if="myOrgs.status === 'active'">
              <vs-button class="mb-base" size="large" color="primary" type="filled" @click.stop="manageOrganization(myOrgs.organization[0].slug || myOrgs.organization[0]._id)">Manage</vs-button>
            </div>
            <div v-else>
              <vs-button class="mb-base" size="large" color="success" type="filled" @click.stop="acceptAdminOrgInvite(myOrgs._id, myOrgs.organization[0].slug || myOrgs.organization[0]._id)">
                Accept Invitation
              </vs-button>  
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- Empty State -->
    <div v-else class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8">
      <img class="lg:w-3/12 w-64" src="@/assets/images/temp-img/empty-organization.svg" />
      <div class="flex flex-col gap-6 justify-center items-center">
        <p class="text-xl text-black font-semibold text-center flex gap-2 flex-col">No Organization Found!</p>
        <router-link to="/organization/create" class="py-2 px-4 bg-primary text-slate-950 w-fit rounded-lg text-lg font-semibold">Create Organization</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js";

export default {
  data() {
    return { constants };
  },
  computed: {
    myOrganizations() { return this.$store.state.organization.myOrganizations; }
  },
  created() {
    const payload = {
      email: this.$store.state.auth.user.email,
      userId: this.$store.state.auth.user._id,
    };
    this.$store.dispatch("organization/fetchAllMyOrganizations", payload);
  },
  methods: {
    manageOrganization(idOrSlug) {
      window.location.href = `/organization/${idOrSlug}/home`;
    },
    acceptAdminOrgInvite(adminId, orgIdOrSlug) {
      this.$store.dispatch("organization/acceptAdminOrgInvite", { adminId })
        .then(() => { 
          if (orgIdOrSlug) window.location.href = `/organization/${orgIdOrSlug}/home`;
        }).catch(err => console.error(err));
    }
  }
};
</script>